import { FlowBlockType, FlowObsoleteBlockType } from 'flow-schema';

import {
  type FlowDefinitionBlockCompatibilityByBlockType,
  FlowDefinitionBlockTypeCompatibility,
} from './types.js';
import { UnknownBlockType } from '../base/baseSchema.js';

/**
 * Transcribed from https://notable-health.atlassian.net/wiki/spaces/notableengineering/pages/3667722258/Skill-ready+blocks
 * as of 2025-12-10
 */
export const SKILL_V2_BLOCK_TYPE_COMPATIBILITY: FlowDefinitionBlockCompatibilityByBlockType = {
  [FlowBlockType.Start]: FlowDefinitionBlockTypeCompatibility.Required,
  [FlowBlockType.Output]: FlowDefinitionBlockTypeCompatibility.Required,
  [FlowBlockType.SubFlowV2]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.IteratorV2]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.Repeat]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.Conditional]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.Switch]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.ScriptedFlow]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.Text]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.FilterList]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.WaitV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.UpdateFlowConfig]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.LlmPrompt]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.Evaluation]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.MedicalNecessityCheck]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.GetNotableObject]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.Fhir]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.OcrV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.InformationExtraction]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.VoiceCallV2]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.VoiceTranscribe]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.HieQueryDocuments]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.HieGetDocuments]:
    FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedBasedOnConfig,
  [FlowBlockType.WaitForFormCompletion]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.Conversation]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.AdvancedFhir]:
    FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedBasedOnConfig,
  [FlowBlockType.HCCAlgorithmBlock]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.DocumentTemplate]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.GenerateFile]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.PatientDataStore]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.Rest]: FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedBasedOnConfig,
  [FlowBlockType.Form]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.FormV2]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.GetFormSet]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.GetInsurances]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.SendEmail]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.SendSms]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.AutomatedVoice]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.Fax]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.HumanTask]: FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedBasedOnConfig,
  [FlowBlockType.UpdateNotableObject]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.Hl7]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.Mirth]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.MontageOnBase]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.RealTimeEligibility]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.InsuranceCard]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.FileConversion]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [FlowBlockType.WaitForSignal]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.Callback]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.CareGapAlgorithmBlock]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.DocumentExtract]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.GetExternalDocumentPacket]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.GetPatient]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.GetPatientOrder]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.GetProvider]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.ExportExternalDocumentPacket]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.ExportTextToBucket]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.ExportToSftp]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.CreateEncounterSummary]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.CreatePatientOrder]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.AsynchronousExportJob]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.CreateNotableObject]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.DocumentSearch]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.GetSftpFile]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.ServiceReview]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.SkillV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  // Retired blocks
  [FlowBlockType.AuthorizationSubmission]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.Wait]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.IteratorV1]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.SubFlowV1]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.VoiceCall]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.Ocr]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.RestApiClassicAuthorization]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.Scheduling]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowBlockType.AsynchronousExtractJob]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  // Obsolete blocks
  [FlowObsoleteBlockType.ObsoleteApiSubmissions]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteGetEncounterSummary]:
    FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteHumanReview]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteSkill]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteSendToLabelboxForReview]:
    FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteWaitForAvailableSchedulingSlot]:
    FlowDefinitionBlockTypeCompatibility.NotAllowed,
  // A flow-api test harness block: it has no block_type_metadata row, so it is never pickable.
  [FlowBlockType.TestLifecycle]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [UnknownBlockType.Unknown]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
};
